export default "__VITE_PUBLIC_ASSET__7e4bb0df__"